var _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Edit"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8489 14.4551H9.40918C9.09868 14.4551 8.84668 14.2031 8.84668 13.8926C8.84668 13.5821 9.09868 13.3301 9.40918 13.3301H14.8489C15.1594 13.3301 15.4114 13.5821 15.4114 13.8926C15.4114 14.2031 15.1594 14.4551 14.8489 14.4551Z",
    fill: "#2D3958"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12111_8816",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Clip 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.786133 0.25H13.6716V14.4547H0.786133V0.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12111_8816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.11884 1.76248L2.05759 10.5937C1.92934 10.7542 1.88209 10.9612 1.92934 11.16L2.44009 13.3237L4.71934 13.2952C4.93609 13.293 5.13634 13.1962 5.26909 13.0312C7.68184 10.0125 12.2816 4.25698 12.4121 4.08823C12.5351 3.88873 12.5831 3.60673 12.5186 3.33523C12.4526 3.05698 12.2793 2.82073 12.0296 2.66998C11.9763 2.63323 10.7126 1.65223 10.6736 1.62148C10.1981 1.24048 9.50434 1.30648 9.11884 1.76248ZM1.99609 14.4547C1.73584 14.4547 1.50934 14.2762 1.44859 14.022L0.834339 11.4187C0.707589 10.8795 0.833589 10.323 1.17934 9.89098L8.24434 1.05448C8.24734 1.05148 8.24959 1.04773 8.25259 1.04473C9.02734 0.118482 10.4283 -0.018018 11.3733 0.740232C11.4108 0.769482 12.6656 1.74448 12.6656 1.74448C13.1216 2.01598 13.4778 2.50123 13.6128 3.07573C13.7471 3.64423 13.6496 4.23073 13.3368 4.72648C13.3136 4.76323 13.2933 4.79473 6.14734 13.7347C5.80309 14.1637 5.28709 14.4135 4.73284 14.4202L2.00359 14.4547H1.99609Z",
    fill: "#2D3958"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4532 6.76353C11.3332 6.76353 11.2132 6.72528 11.1105 6.64728L7.02146 3.50628C6.77546 3.31728 6.72896 2.96478 6.91796 2.71728C7.10771 2.47128 7.46021 2.42553 7.70696 2.61453L11.7967 5.75478C12.0427 5.94378 12.0892 6.29703 11.8995 6.54378C11.7892 6.68778 11.622 6.76353 11.4532 6.76353Z",
    fill: "#2D3958"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilIcon);
export default __webpack_public_path__ + "static/media/Edit-pencil-icon.dfd0bf0f99d8ef561d76ccc66e83375d.svg";
export { ForwardRef as ReactComponent };